export const errorMappingWithSubScenario = {
  // bid
  CampaignServiceBidAmountsGreaterThanCeilingPrice: {
    newcampaign: 'Error_BidAmountGreaterThanCeilingPrice',
    newadgroup: 'Error_BidAmountGreaterThanCeilingPrice',
  },

  // BulkUpsert error with Error Number 4326
  CampaignServiceSharedEntityIdInvalid: {
    PerformanceMaxCampaignCreation: 'Error_CampaignServiceBrandListIdInvalid',
    PerformanceMaxCampaignSettings: 'Error_CampaignServiceBrandListIdInvalid',
    brandList: 'Error_Campaign_API_BrandList_CampaignServiceSharedEntityIdInvalid',
  },

  CampaignServiceSharedEntityLimitExceeded: {
    brandList: 'Error_Campaign_API_BrandListSharedEntityLimitExceeded',
  },
};
